import { combineReducers } from 'redux';

import tots from './tots';
import peticioObtenirMunicipisEnCurs from './peticioObtenirMunicipisEnCurs';

export default combineReducers({
    tots,
    peticioObtenirMunicipisEnCurs
});



// WEBPACK FOOTER //
// ./src/reducers/municipis/index.js